import { useEvent } from '@emerald-works/react-event-bus-client'

export const AI_SKILLS_PRACTICE_FROM = {
  NAVBAR: 'navbar',
  HOME_RAIL: 'home-rail',
  HOME_PROMO: 'home-promo',
  LANDING_PAGE: 'landing-page'
}

const useTrackAiSkillsPracticeEvent = () => {
  const [aiSkillsPracticePageViewed, aiSkillsPracticeLaunched] = useEvent([
    { eventName: 'aiSkillsPracticePageViewed' },
    { eventName: 'aiSkillsPracticeLaunched' }
  ])

  const trackPageViewed = (from) => {
    const payload = from ? { from } : {}
    aiSkillsPracticePageViewed.trigger(payload)
  }

  const trackLaunched = (from, data = {}) => {
    aiSkillsPracticeLaunched.trigger({ from, ...data })
  }

  return {
    trackPageViewed,
    trackLaunched
  }
}

export default useTrackAiSkillsPracticeEvent
